import { Component, NgZone } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { PouchService } from './services/pouch-service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  rootPage;
  credentials: any;
  showClientMessage: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, public alertCtrl: AlertController, public platform: Platform, public router: Router, public http: HttpClient, public db: PouchService) {
    platform.ready().then(() => {});
    this.db.getJSON('./assets/data/translations.json').subscribe((data) => {
      this.db.translations = data;
    });
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.router.url), // Get the current URL
        map((url) => this.extractDatabaseName(url)) // Extract the database name from the URL
      )
      .subscribe(async (database) => {
        if (this.router.url == '/LoginCustomerPage' || this.router.url == '/CustomerManagementPage' || this.router.url == '/PrintEntityPage' || this.router.url == '/PrintReceiptPage') {
          this.db.database = localStorage.getItem('customer_database');
          this.db.database_name = localStorage.getItem('customer_database_name');
          this.db.gsetting = JSON.parse(localStorage.getItem('customer_setting'));
          this.showClientMessage = false;
        } else if (this.router.url.includes('$') || !this.router.url.includes('Page')) {
          this.showClientMessage = false;
        } else if (this.router.url == '/') {
          this.showClientMessage = false;
          this.router.navigateByUrl('/LoginCustomerPage');
        } else if (database) {
          const clientExists = await this.db.setdatabase(database);
          this.showClientMessage = !clientExists;
        } else {
          this.showClientMessage = true;
        }
      });
  }

  // Helper method to extract the database name from the URL
  extractDatabaseName(url: string): string | null {
    const segments = url.split('/');
    const prescriptionIndex = segments.indexOf('prescription');
    if (prescriptionIndex > 0) {
      return segments[prescriptionIndex - 1]; // The database name is the segment before 'prescription'
    } else if (localStorage.getItem('customer_database')) {
      return localStorage.getItem('customer_database');
    } else {
      return null;
    }
  }
}

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
